module.exports = __webpack_public_path__ + "img/484.b3302f02.jpg";